import type { MediaType } from '@/domain/model/MediaType';

export const ACCEPTED_MEDIA_TYPES = 'audio/*,video/*';

export const mediaTypeLabelKey = (mediaType: MediaType): string =>
  mediaType === 'AUDIO' ? 'common.mediaTypeAudio' : 'common.mediaTypeVideo';
